var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 341.439 327.863",
    enableBackground: "new 0 0 341.439 327.863",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M107.924,101.924L6,203.849l19.99,19.99l19.99,19.991l5.393-4.999c3.024-2.761,8.021-6.049,11.047-7.496 c13.678-6.181,29.986-0.132,36.956,13.677c5.918,12.1,3.683,24.857-6.313,36.036l-4.735,5.128l19.99,19.991l19.99,19.991 l101.662-101.661C285.732,168.734,331.5,122.44,331.5,121.651c0-0.657-8.68-9.995-19.333-20.648l-19.2-19.333l-6.709,5.918 c-14.203,12.494-32.482,11.969-43.53-1.052c-10.652-12.494-9.601-28.144,2.761-41.821l4.867-5.392L230.76,19.596 C219.976,8.812,210.9,0,210.506,0S163.949,45.899,107.924,101.924z M217.608,34.063l6.443,6.576l-3.155,6.97 c-4.473,9.863-4.604,30.249-0.264,39.585c6.971,15.124,23.804,26.83,40.507,28.276c8.548,0.657,20.778-2.104,26.829-5.918 c3.025-1.973,3.288-1.709,10.126,4.998l7.103,7.102l-88.773,88.773l-88.772,88.772l-6.839-6.839l-6.839-6.839L117,279.47 c12.098-24.199,1.182-53.658-24.331-65.363c-5.261-2.498-8.681-3.024-18.938-3.024c-10.916,0-13.415,0.394-19.728,3.551 l-7.233,3.682l-7.232-7.233l-7.234-7.233l88.115-88.115c48.397-48.397,88.773-88.115,89.431-88.115 C210.637,27.618,214.188,30.512,217.608,34.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M161.846,101.924l-5.787,5.918l6.839,6.839l6.839,6.97l6.576-6.576l6.575-6.445l-6.181-6.313 c-3.42-3.418-6.84-6.313-7.629-6.313C168.29,96.006,165.002,98.636,161.846,101.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M190.121,128.885l-6.576,6.576l6.576,6.576l6.576,6.576l6.576-6.576l6.575-6.576l-6.575-6.576l-6.576-6.576 L190.121,128.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M216.688,156.24l-6.182,6.313l6.445,6.313l6.443,6.444l3.814-2.761c1.973-1.448,5.128-4.209,6.839-6.051 l3.288-3.419l-6.445-6.576c-3.551-3.682-6.839-6.576-7.232-6.576C223.264,149.927,220.106,152.821,216.688,156.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.d5086c8c3cbc063a4b2c1773b6d92d35.svg";
export { ForwardRef as ReactComponent };